<template>
  <v-row no-gutters>
    <feature-card-basic :layer="layer">
      <template #top v-if="collisionsVisible">
        <wat-sew-collisions-info :layer-id="layerId" :feature-id="currentFeatureId" />
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import FeatureCardBasic from '@/components/FeatureCardBasic';
import WatSewCollisionsInfo from '@/components/WatSewCollisionsInfo';
export default {
  name: 'FeatureCardTransmissionEasements',
  components: { FeatureCardBasic, WatSewCollisionsInfo },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAdminEnabled: get('admin/settingsValues@transmission_easement_2_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@TRANSMISSION_EASEMENT_2_MODULE.enabled'),
    modulesPermissions: get('users/toolsPermissions@TRANSMISSION_EASEMENT_2_MODULE'),
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    layerId() {
      return this.layer?.id || null;
    },
    permissions() {
      const value = this.modulesPermissions.main_value;
      return value > 0;
    },
    collisionsVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions;
    },
  },
};
</script>
